export default __webpack_public_path__ + "static/media/n_wdt_c_3.0998fc6f.mp3";